import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ReOpenPurchaseOrderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .content {
    width: 100%;
    padding: 24px 0px;

    ${responsive.MOBILE`
      padding: 0 0x;
      overflow-x: hidden;
      width: 100%;
      box-sizing: border-box;
    `}
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100% !important;
  }

  .horizontal-direction {
    display: flex;
    flex-direction: row;
    gap: 8px;
    ${responsive.MOBILE`
      align-items: center;
    `}
  }
`;
